export default __webpack_public_path__ + "static/media/Logo.prepacademy.40d163f2.svg";